const filterTopicTypes = (modalType, parentType, topicTypes) => {
    let filteredTypes = [];

    if (modalType === 'newTopic') {
        // Strand and Substrand when creating new topic
        filteredTypes = topicTypes.slice(0, 2);
        return filteredTypes;
    }
    parentType = parentType && parentType.toLowerCase();
    switch (parentType) {
    case 'descriptor':
    // Descriptor when parent is Descriptor
        filteredTypes = topicTypes.slice(0, 1);
        break;
    case 'strand':
        // Standard when parent is Strand
        filteredTypes = topicTypes.slice(2, 3);
        break;
    case 'standard':
        // Learning Journey when parent is Standard
        filteredTypes = topicTypes.slice(3, 4);
        break;
    case 'learningjourney':
        // Step when parent is Learning Journey
        filteredTypes = topicTypes.slice(4, 5);
        break;

    default:
        break;
    }

    return filteredTypes;
};

export default filterTopicTypes;



// WEBPACK FOOTER //
// ./app/components/add-topic/utils.js